import {
  FieldDefinition,
  FieldsOption,
} from "src/base-components/FilterPopover/types";
import { SELECT_DIVIDER } from "src/base-components/Select";

export const isFieldDefinition = (
  option: FieldsOption,
): option is FieldDefinition => option !== SELECT_DIVIDER;
